import DealsInsurance from './DealsInsurance'
export default DealsInsurance
